import { useEffect } from 'react';
import { refreshSupabaseSessionOnce } from '../utils/asyncReliability';

/**
 * After sleep/wake or long idle tabs, proactively refresh the Supabase session so writes
 * (quotes, invoices, billing) do not hang on stale JWTs.
 *
 * @param {import('@supabase/supabase-js').SupabaseClient | null} supabase
 */
export function useAppResumeAuth(supabase) {
  useEffect(() => {
    if (!supabase) return undefined;

    const onVisible = () => {
      if (typeof document === 'undefined' || document.visibilityState !== 'visible') return;
      void refreshSupabaseSessionOnce(supabase);
    };

    const onFocus = () => {
      void refreshSupabaseSessionOnce(supabase);
    };

    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onFocus);

    return () => {
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onFocus);
    };
  }, [supabase]);
}
